import { getSchemaItem } from "./faqSchema";
import site from "config/meta";

export const generateVideoGameSchema = game => ({
  "@context": "https://schema.org",
  "@type": "VideoGame",
  name: game?.title || game.meta.title,
  description: game.meta.description,
  image: {
    '@type': 'ImageObject',
    creator: {
      '@type': 'Organization',
      name: 'EpicPlay'
    },
    url: site.siteMetadata.siteUrl + game.bannerImageUrl.src,
    width: 952,
    height: 433
  },
  url: site.siteMetadata.siteUrl + "/games/" + game.pathname,
  inLanguage: ["English"],
  publisher: {
    '@type': 'Organization',
    name: 'EpicPlay',
    logo: {
      '@type': 'ImageObject',
      creator: {
        '@type': 'Organization',
        name: 'EpicPlay'
      },
      url: site.siteMetadata.logo,
      width: 140,
      height: 24
    }
  },
  genre: game.categories.map(item => item.substring(0,1)+item.substring(1,item.length).toLowerCase() + " game"),
  gamePlatform: ["Browser","Online","PC","Android","iOS"],
  operatingSystem: ["Windows 7","OS X 8","Android 4.4"],
  playMode: "SinglePlayer",
});

export const generateGameBreadCrumbSchema = game => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: site.siteMetadata.siteUrl + "/games",
    },
    {
      "@type": "ListItem",
      position: 2,
      name: game.meta.title,
      item: site.siteMetadata.siteUrl + "/games/" + game.pathname,
    },
  ],
});